import { configureStore } from '@reduxjs/toolkit';
import areaLevelReducer from './areaLevelSlice';
import diseaseReducer from "./diseaseSlice";
import weekOfYearReducer from './weekOfYearSlice';
import iaamReducer from './iaamSlice';
import profileReducer from './profileSlice';
import eocActiveReducer from './eocActiveSlice'
import eocConfigReducer from './eocConfigSlice'
import activityActiveReducer from './activityActiveSlice'
import activityHistoryReducer from './activityHistorySlice'
import activityConfigReduder from './activityConfigSlice'
import tabReducer from './tabSlice'
import eocHistorySlice from './eocHistorySlice';
import areaLocationReducer from './areaLocationSlice';
import areaSelectedSlice from './areaSelectedSlice';
import areaDataSlice from './areaDataSlice';
import monitorPageSlice from './monitorPageSlice';
import mapDataSelectedSlice from './mapDataSelectedSlice';
export default configureStore({
    reducer: {
        disease: diseaseReducer,
        weekofyear: weekOfYearReducer,
        arealevel: areaLevelReducer,
        arealocation: areaLocationReducer,
        iaam: iaamReducer,
        profile: profileReducer,
        eocActive: eocActiveReducer,
        eocConfig: eocConfigReducer,
        activityConfig: activityConfigReduder,
        activityActive: activityActiveReducer,
        activityHistory: activityHistoryReducer,
        tab: tabReducer,
        eocHistory: eocHistorySlice,
        areaselected: areaSelectedSlice,
        areadata: areaDataSlice,
        monitorpage: monitorPageSlice,
        mapdata: mapDataSelectedSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }),
});
